<template>
  <TMenuItem
    class="flex items-center justify-between gap-x-4"
    :to="computedTo"
    :size="size"
   
  >
    <span class="font-semibold space-y-1 flex flex-col">
      <span>{{ t('pageLink.listAnRV') }}</span>
      <span
        :class="[
          'block text-gray-500 font-light',
          sizeClass,
        ]"
      >
        {{ t('pageLink.listAnRVCallout') }}
      </span>
    </span>

    <img
      :src="listAnRvIcon"
      alt="list-an-rv"
      class="h-10"
    >
  </TMenuItem>
</template>

<script setup lang="ts">
import type { MenuItemSize } from '~/components/_tailwind/menu/types'

const props = withDefaults(defineProps<{
  size?: MenuItemSize
}>(), {
  size: 'md',
})

const { t } = useI18n()
const localePath = useLocalePath()

const { getStaticImage } = useImage()
const listAnRvIcon = computed(() => getStaticImage({
  path: '/web-app/list-an-rv-icon.webp',
}))

const { userExists } = useUser()

const computedTo = computed(() => {
  if (userExists.value) {
    return localePath({ name: 'dashboard-rvs-new', params: { dashboard: 'host' } })
  }

  return localePath({ name: 'owner' })
})

const sizeClass = computed(() => {
  if (props.size === 'lg') {
    return 'text-lg'
  }

  if (props.size === 'md') {
    return 'text-sm'
  }

  return 'text-sm leading-4'
})
</script>
